import { render } from "./Error.vue?vue&type=template&id=7e0988cf&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import exportComponent from "F:\\laragon\\www\\CMHLMC-Hostel-VUE-Laravel\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0988cf"]])

export default __exports__